<template>
	<section v-if="record"
	         :class="{'social-learning-attached-preview-video' : videoSize === 'xSmall'}">
		<div v-if="!record.id">
			<img class="w-80 h-80" :class="size" :src="thumbnailUrl" alt=""/>
			<span class="video-play-button video-play-button-control-other cursor-default">
        <div class="video-play-button-placeholder"></div>
      </span>
		</div>
		<video-player
				v-else-if="record.subFileResourceUri && record.subFileResourceUri.length > 0"
				:options="options"
				:playsinline="true"
				:class="fullSizeVideo ?
        'b-radius4 video-player video-player-box board-list-video board-list-slider w-full'
        : ' video-player-box attached-image-preview-126 position-relative'"
		/>
		<div v-else :class="calcVideoSize">
			<div class="noVideoData">
				<div class="t-helper font-r t-center">{{ $t('3753') }}</div>
			</div>
		</div>
	</section>
</template>

<script>
import {videoPlayer} from "vue-video-player";
import "video.js/dist/video-js.css";

import {mediaTypeConstants} from "@/utils/enum/MediaTypeConstants";

export default {
	props: ['record', 'fullSizeVideo', 'videoSize', 'size'],
	
	name: "VideoTranscode",
	
	components: {
		'video-player': videoPlayer
	},
	
	data() {
		return {
			thumbnailUrl: require('@/images/blackBackground.jpg'),
			options: {
				muted: false,
				language: "en",
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [
					{
						type: '',
						src: ''
					}
				],
				height: "100%",
				width: "100%",
				poster: ''
			}
		};
	},
	
	computed: {
		calcVideoSize() {
			switch (this.videoSize) {
				case 'small':
					return 'smallSizeVideo'
				case 'medium':
					return 'mediumSizeVideo'
				case 'large':
					return 'fullSizeVideo'
			}
		}
	},
	
	mounted() {
		if (!this.record) {
			return;
		}
		Object.assign(this.options, {
			sources: [
				{
					type: this.record.contentType,
					src: this.record.resourceUri
				}
			],
			height: this.fullSizeVideo ? mediaTypeConstants.VIDEO_THUMBNAIL_SIZE.large_height : mediaTypeConstants.VIDEO_THUMBNAIL_SIZE.small,
			width: this.fullSizeVideo ? mediaTypeConstants.VIDEO_THUMBNAIL_SIZE.large_width : mediaTypeConstants.VIDEO_THUMBNAIL_SIZE.small
		});
	}
}
</script>

<style scoped>
.smallSizeVideo {
	height: 80px;
	width: 80px;
}

.mediumSizeVideo {
	height: 126px;
	width: 126px;
}

.fullSizeVideo {
	height: 437px;
	width: 100%;
}

.noVideoData {
	background: #000;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	height: inherit;
	width: inherit;
	top: 50%;
	left: 50%;
	padding: 4px;
	box-sizing: border-box;
}

.video-play-button {
	left: 50% !important;
	top: 50% !important;
	-webkit-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 40px !important;
	height: 40px !important;
	border-radius: 1.9em !important;
	font-size: 5em !important;
}

.video-play-button-control-other {
	font-size: 3em;
	line-height: 1.5em;
	height: 1.63332em;
	width: 3em;
	position: absolute;
	display: block;
	top: 10px;
	left: 10px;
	padding: 0;
	cursor: pointer;
	opacity: 1;
	border: 2px solid #fff;
	border-radius: 50% !important;
	background-color: rgba(43, 51, 63, 0.7);
	-webkit-transition: all 0.4s;
	transition: all 0.4s;
}
.video-play-button-placeholder {
	content: "";
	display: block;
	width: 18px;
	height: 13px;
	bottom: 0;
	transform: translate(75%, 50%);
	border: 0;
	background: transparent;
	box-sizing: border-box;
	border-color: transparent transparent transparent #202020;
	border-style: solid;
	border-width: 10px 0 10px 18px;
	filter: invert(100%);
}
</style>
